import dayjs from "dayjs";
export const convertTimestampToDate = (timestamp) => {
  if (timestamp !== "") {
    const date = new Date(parseInt(timestamp, 10)); // Convert timestamp to a Date object
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
    return formattedDate;
  } else {
    return "";
  }
};

export const convertTimeToDate = (time) => {
  if (time) {
    const date = new Date(time); // Convert timestamp to a Date object
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
    return formattedDate;
  } else {
    return "";
  }
};

export const hazardRequestFields = [
  {
    label: "Select Hazard Type",
    name: "categoryType",
    type: "select",
    options: [
      { value: "Falls from heights", label: "Falls from heights" },
      { value: "Struck by incidents", label: "Struck by incidents" },
      {
        value: "Caught-in/between accidents",
        label: "Caught-in/between accidents",
      },
      { value: "Electrical hazards", label: "Electrical hazards" },
      {
        value: "Trench and excavation collapses",
        label: "Trench and excavation collapses",
      },
      { value: "Slips, trips, and fall", label: "Slips, trips, and falls" },
      {
        value: "Trench and excavation collapses",
        label: "Trench and excavation collapses",
      },
      { value: "Machine guarding issues", label: "Machine guarding issues" },
      { value: "Forklift and Vehicle", label: "Forklift and Vehicle" },
      { value: "Fire and explosions", label: "Fire and explosions" },
      {
        value: "Biological/Chemical hazards",
        label: "Biological/Chemical hazards",
      },
      { value: "Cuts and lacerations", label: "Cuts and lacerations" },
      { value: "Equipment malfunctions", label: "Equipment malfunctions" },
      { value: "Scaffolding instability", label: "Scaffolding instability" },
      { value: "Falling object incidents", label: "Falling object incidents" },
      { value: "Adverse Weather", label: "Adverse Weather" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    label: "Hazard Description",
    name: "description",
  },
  {
    label: "Hazard Location",
    name: "sendLocation",
  },
  {
    label: "Reported By",
    name: "reportedBy",
  },
  {
    label: "Time & Date of Observation",
    name: "dateOfObservation",
    type: "datetime-local",
  },
  {
    label: "Attachment",
    name: "attachedFile",
    type: "file",
  },
  {
    label: "Individuals Affected",
    name: "individualsList",
  },
  {
    label: "Risk",
    name: "risk",
    type: "select",
    options: [
      { value: "Low", label: "Low" },
      { value: "Moderate", label: "Moderate" },
      { value: "High", label: "High" },
      { value: "Critical", label: "Critical" },
    ],
  },
  {
    label: "Priority",
    name: "priority",
    type: "select",
    options: [
      {
        value: "Low Priority - Address in routine schedules",
        label: "Low Priority - Address in routine schedules",
      },
      {
        value: "Medium Priority - Address soon",
        label: "Medium Priority - Address soon",
      },
      {
        value: "High Priority - Immediate action required",
        label: "High Priority - Immediate action required",
      },
    ],
  },
  {
    label: "Additional Comments",
    name: "additionalComments",
  },
  {
    label: "Manager Message",
    name: "managerNotes",
  },
];

export const incidentRequestFields = [
  {
    label: "Select Incident Type",
    name: "categoryType",
    options: [
      { value: "Falls from heights", label: "Falls from heights" },
      { value: "Struck by incidents", label: "Struck by incidents" },
      {
        value: "Caught-in/between accidents",
        label: "Caught-in/between accidents",
      },
      { value: "Electrical hazards", label: "Electrical hazards" },
      {
        value: "Trench and excavation collapses",
        label: "Trench and excavation collapses",
      },
      { value: "Slips, trips, and fall", label: "Slips, trips, and falls" },
      {
        value: "Trench and excavation collapses",
        label: "Trench and excavation collapses",
      },
      { value: "Machine guarding issues", label: "Machine guarding issues" },
      { value: "Forklift and Vehicle", label: "Forklift and Vehicle" },
      { value: "Fire and explosions", label: "Fire and explosions" },
      {
        value: "Biological/Chemical hazards",
        label: "Biological/Chemical hazards",
      },
      { value: "Cuts and lacerations", label: "Cuts and lacerations" },
      { value: "Equipment malfunctions", label: "Equipment malfunctions" },
      { value: "Scaffolding instability", label: "Scaffolding instability" },
      { value: "Falling object incidents", label: "Falling object incidents" },
      { value: "Adverse Weather", label: "Adverse Weather" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    label: "Incident Description",
    name: "description",
  },
  {
    label: "Incident Location",
    name: "sendLocation",
  },
  {
    label: "Reported By",
    name: "reportedBy",
  },
  {
    label: "Time & Date of Observation",
    name: "dateOfObservation",
    type: "datetime-local",
  },
  {
    label: "Attachment",
    name: "attachedFile",
    type: "file",
  },
  {
    label: "Individuals Affected",
    name: "individualsList",
  },
  {
    label: "Severity",
    name: "severity",
  },
  {
    label: "Risk",
    name: "risk",
    type: "select",
    options: [
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
      { value: "3", label: "4" },
    ],
  },
  {
    label: "Priority",
    name: "priority",
    type: "select",
    options: [
      { value: "High", label: "High" },
      { value: "Medium", label: "Medium" },
      { value: "Low", label: "Low" },
    ],
  },
  {
    label: "Additional Comments",
    name: "additionalComments",
  },
  {
    label: "Manager Message",
    name: "managerNotes",
  },
];

export const accidentRequestFields = [
  {
    label: "Time & Date of Observation",
    name: "dateOfObservation",
    type: "datetime-local",
  },
  {
    label: "Select Accident Type",
    name: "categoryType",
    options: [
      { value: "Falls from heights", label: "Falls from heights" },
      { value: "Struck by incidents", label: "Struck by incidents" },
      {
        value: "Caught-in/between accidents",
        label: "Caught-in/between accidents",
      },
      { value: "Electrical hazards", label: "Electrical hazards" },
      {
        value: "Trench and excavation collapses",
        label: "Trench and excavation collapses",
      },
      { value: "Slips, trips, and falls", label: "Slips, trips, and falls" },
      {
        value: "Trench and excavation collapses",
        label: "Trench and excavation collapses",
      },
      { value: "Machine guarding issues", label: "Machine guarding issues" },
      { value: "Forklift and Vehicle", label: "Forklift and Vehicle" },
      { value: "Fire and explosions", label: "Fire and explosions" },
      {
        value: "Biological/Chemical hazards",
        label: "Biological/Chemical hazards",
      },
      { value: "Cuts and lacerations", label: "Cuts and lacerations" },
      { value: "Equipment malfunctions", label: "Equipment malfunctions" },
      { value: "Scaffolding instability", label: "Scaffolding instability" },
      { value: "Falling object incidents", label: "Falling object incidents" },
      { value: "Adverse Weather", label: "Adverse Weather" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    label: "Accident Description",
    name: "description",
  },
  {
    label: "Reported By",
    name: "reportedBy",
  },

  {
    label: "Accident Location",
    name: "sendLocation",
  },

  {
    label: "Individuals Affected",
    name: "individualsList",
  },
  {
    label: "Equipment",
    name: "equipmentList",
  },
  {
    label: "Material",
    name: "materialList",
  },
  {
    label: "Attachment",
    name: "attachedFile",
    type: "file",
  },

  {
    label: "Additional Comments",
    name: "additionalComments",
  },
  {
    label: "Manager Message",
    name: "managerNotes",
  },
];

export const holidayRequestFields = [
  {
    label: "Leave Type",
    name: "leaveType",
    type: "select",
    options: [
      { value: "Annual Leave", label: "Annual Leave" },
      { value: "Sick Leave", label: "Sick Leave" },
    ],
  },
  {
    label: "Date Range",
    name: "dateRange",
    type: "date-range",
  },
  { label: "Additional Notes", name: "additionalNotes", fullWidth: true },
  {
    label: "Attachment(s)",
    name: "attachedFile",
    type: "file",
    fullWidth: true,
  },
  {
    label: "Manager Message",
    name: "managerNotes",
  },
];

export const overTimeRequestFields = [
  {
    label: "Project",
    name: "projectType",
    type: "select",
    options: [
      { value: "Swap Boiler", label: "Swap Boiler" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    label: "Sub-Project",
    name: "subProjectType",
    type: "select",
    options: [
      { value: "Survey", label: "Survey" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    label: "Reason",
    name: "leaveType",
    type: "select",
    options: [
      { value: "Extra Hours", label: "Extra Hours" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    label: "Instruction Received On",
    name: "dateOfObservation",
    type: "text",
  },
  {
    label: "OverTime Entries",
    name: "overtimeEntries",
    type: "dateRangeList",
  },
  {
    label: "Instructed By",
    name: "instructedBy",
    type: "text",
    fullWidth: true,
  },
  {
    label: "Position",
    name: "position",
    type: "text",
    fullWidth: true,
  },
  {
    label: "Variation Order No",
    name: "variationOrderNo",
    type: "text",
    fullWidth: true,
  },

  {
    label: "Additional Notes",
    name: "additionalNotes",
    type: "text",
    fullWidth: true,
  },
  {
    label: "Attachment(s)",
    name: "attachedFile",
    type: "file",
    fullWidth: true,
  },
  {
    label: "Manager Message",
    name: "managerNotes",
  },
];

export const unavailableDates = [
  dayjs("2024-11-25"),
  dayjs("2024-11-06"),
  dayjs("2024-12-15"),
];

export const shouldDisableDate = (date) => {
  return unavailableDates.some((unavailableDate) =>
    dayjs(date).isSame(unavailableDate, "day"),
  );
};

export const convertFileFromBackendResponse = async (fileData) => {
  const response = await fetch(fileData.url);
  const blob = await response.blob();

  // Create a File object using the Blob and metadata
  const file = new File([blob], fileData.filename, {
    type: fileData.extension ? `application/${fileData.extension}` : blob.type,
  });

  return file;
};

export const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return "th"; // Covers 4th-20th
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const generateChartData = (items, time, user) => {
  const dateCounts = {};
  const statuses = {
    Queried: {
      border: "rgba(33, 150, 243, 1)",
      background: "rgba(33, 150, 243, 0.2)",
      label: "Queried",
    },
    Rejected: {
      border: "rgba(255, 82, 82, 1)",
      background: "rgba(255, 82, 82, 0.2)",
      label: "No Action req",
    },
    Pending: {
      border: "rgba(255, 193, 7, 1)",
      background: "rgba(255, 193, 7, 0.2)",
      label: "Pending",
    },
    Approved: {
      border: "rgba(76, 175, 80, 1)",
      background: "rgba(76, 175, 80, 0.2)",
      label: "Escalated",
    },
  };

  Object.keys(statuses).forEach((status) => {
    dateCounts[status] = {};
  });

  items.forEach((item) => {
    const date = dayjs(item.updatedAt).format("DD/MMM");
    const status = item.status;
    if (statuses[status] && (item.owner === user || user === "All")) {
      dateCounts[status][date] = (dateCounts[status][date] ?? 0) + 1;
    }
  });
  const today = dayjs();
  const startDate = today.subtract(time, "day");
  const labels = [];
  for (let date = startDate; date.isBefore(today); date = date.add(1, "day")) {
    labels.push(date.format("DD/MMM"));
  }

  // Generate datasets for each status
  const datasets = Object.keys(statuses).map((status) => {
    const data = statuses[status];
    return {
      label: data.label,
      data: labels.map((date) => dateCounts[status][date] || 0), // Map counts for each date
      borderColor: data.border,
      backgroundColor: data.background,
      fill: true,
    };
  });

  return {
    labels,
    datasets,
  };
};

export const dummyChartData = {
  labels: ["10 Nov", "17 Nov", "24 Nov", "1 Dec", "8 Dec"], // X-axis labels
  datasets: [
    {
      label: "Last 30 Days",
      data: [200, 400, 600, 1000, 400], // Current data
      borderColor: "rgba(33, 150, 243, 1)", // Blue line
      backgroundColor: "rgba(33, 150, 243, 0.2)",
      fill: true,
    },
    {
      label: "Preceding Period",
      data: [300, 500, 800, 1500, 500], // Preceding data
      borderColor: "rgba(158, 158, 158, 1)", // Gray line
      backgroundColor: "rgba(158, 158, 158, 0.2)",
      fill: true,
      borderDash: [5, 5],
    },
  ],
};

export const mappingStatus = {
  Pending: "Pending",
  Queried: "Queried",
  Approved: "Escalated",
  Rejected: "No Action req",
};

export const findKeyByValue = (value) => {
  return Object.keys(mappingStatus).find((key) => mappingStatus[key] === value);
};

export const getAddress = async ({ lat, lng }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.status === "OK") {
      const formattedAddress = data.results[0]?.formatted_address;
      return formattedAddress;
    } else {
      return "Geocoding failed";
    }
  } catch (error) {
    return "Error fetching the geocoding data";
  }
};

export const convertToBodyParts = (individualsAffected) => {
  if (!individualsAffected) return [];
  return individualsAffected?.map((individual, index) => ({
    id: index,
    name: individual.name,
    conscious: false, // assuming default value as `false`, can be adjusted
    bodyParts:
      individual.bodyPartsAffected &&
      individual.bodyPartsAffected.reduce((acc, bodyPart) => {
        acc[bodyPart] = true;
        return acc;
      }, {}),
  }));
};
